/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { GetAllByClassResp } from '../models/get-all-by-class-resp';
import { GetByCodeResp } from '../models/get-by-code-resp';

@Injectable({
  providedIn: 'root',
})
export class StatusService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getByCode
   */
  static readonly GetByCodePath = '/status/code/{code}';

  /**
   * Get statute by code
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByCode$Response(params: {

    /**
     * statute code
     */
    code: string;
  }): Observable<StrictHttpResponse<GetByCodeResp>> {

    const rb = new RequestBuilder(this.rootUrl, StatusService.GetByCodePath, 'get');
    if (params) {
      rb.path('code', params.code, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetByCodeResp>;
      })
    );
  }

  /**
   * Get statute by code
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getByCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByCode(params: {

    /**
     * statute code
     */
    code: string;
  }): Observable<GetByCodeResp> {

    return this.getByCode$Response(params).pipe(
      map((r: StrictHttpResponse<GetByCodeResp>) => r.body as GetByCodeResp)
    );
  }

  /**
   * Path part for operation getAllByClass
   */
  static readonly GetAllByClassPath = '/status/class/{class}';

  /**
   * Get statute by class
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllByClass()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllByClass$Response(params: {

    /**
     * statute class name
     */
    class: string;
  }): Observable<StrictHttpResponse<GetAllByClassResp>> {

    const rb = new RequestBuilder(this.rootUrl, StatusService.GetAllByClassPath, 'get');
    if (params) {
      rb.path('class', params.class, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetAllByClassResp>;
      })
    );
  }

  /**
   * Get statute by class
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllByClass$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllByClass(params: {

    /**
     * statute class name
     */
    class: string;
  }): Observable<GetAllByClassResp> {

    return this.getAllByClass$Response(params).pipe(
      map((r: StrictHttpResponse<GetAllByClassResp>) => r.body as GetAllByClassResp)
    );
  }

}
